import { render, staticRenderFns } from "./PriorTable.vue?vue&type=template&id=73b3730b&"
import script from "./PriorTable.vue?vue&type=script&lang=js&"
export * from "./PriorTable.vue?vue&type=script&lang=js&"
import style0 from "./PriorTable.vue?vue&type=style&index=0&id=73b3730b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports